module.exports = __webpack_public_path__ + "img/1-default.8d409d88.jpg";